import type { FC } from 'react';
import Content from '../Content';
import ButtonGoToSession from '../../Shared/ButtonGoToSession';
import ButtonHideSession from '../../Shared/ButtonHideSession';
import { DegradationProperties } from '../../../../../../core/domain/map';

type Props = {
    networkProperties: DegradationProperties | null;
};

const DegradationPopupOnClick: FC<Props> = ({ networkProperties }) => {
    if (!networkProperties) {
        return null;
    }

    return (
        <>
            <Content properties={networkProperties} />
            {networkProperties.imageCumulStart != null && (
                <ButtonGoToSession
                    sessionId={networkProperties.sessionId}
                    cumulStartSession={Number(networkProperties.imageCumulStart)}
                />
            )}
            <ButtonHideSession sessionId={networkProperties.sessionId} />
        </>
    );
};

export default DegradationPopupOnClick;
